import { registerType } from '@chewy/chat-library-common';
import {
  General,
  ManageAccountCard,
  OrderCard,
  OrderCardMultiItem,
  OrderCardPackage,
  OrderCardPackageSelector,
  OrderCardSelector,
  OrderCardPackages,
  ProductCard,
  ProductCardSelector,
  Thumbnail,
  ThumbnailSelector,
  HeartBurstMessage,
  FloatingCirclesMessage,
  PetProfileCard,
  PetProfileCardSelector,
  FileCard,
  ChatWrapupCard,
  PrescriptionCardSelector,
  PrescriptionCard,
  WelcomeBack,
  WelcomeMessage,
  MedicineCabinetCard
} from '@chewy/chat-library-message-widgets';

import {
  StructuredMessage,
  AgentTransferMessage,
  AgentJoinedIndicator,
  TextWithHeart,
  UserActionButton,
  ChatEndedIndicator,
  AgentDisconnectedIndicator
} from '@chewy/chat-library-components';

let isRegistrySeeded = false;

export function seedChatbotRegistry() {
  // Prevent duplicate registrations
  if (isRegistrySeeded) {
    console.log('[ChatbotRegistry] Already seeded, skipping...');
    return;
  }

  console.log('[ChatbotRegistry] 🌱 Seeding widget registry...');

  // General & Text components
  registerType({ type: 'text', component: General });
  registerType({ type: 'general', component: General });

  // Order cards and components
  registerType({ type: 'ordercard', component: OrderCard as any });
  registerType({ type: 'orderscard', component: OrderCardSelector as any });

  registerType({ type: 'ordercardmultipleitem', component: OrderCardMultiItem as any });
  registerType({ type: 'ordercardsmultiitem', component: OrderCardMultiItem as any });

  registerType({ type: 'ordercardpackage', component: OrderCardPackage as any });
  registerType({ type: 'ordercardspackage', component: OrderCardPackageSelector as any });
  registerType({ type: 'ordercardspackages', component: OrderCardPackages as any });

  // Prescription components
  registerType({ type: 'prescriptioncard', component: PrescriptionCard as any });
  registerType({ type: 'prescriptionscard', component: PrescriptionCardSelector as any });

  // Product components
  registerType({ type: 'productcard', component: ProductCard as any });
  registerType({ type: 'productcards', component: ProductCardSelector as any });

  // Pet components
  registerType({ type: 'petprofilecard', component: PetProfileCard as any });
  registerType({ type: 'petprofilescard', component: PetProfileCardSelector as any });

  // Thumbnail components
  registerType({ type: 'thumbnail', component: Thumbnail as any });
  registerType({ type: 'thumbnailcards', component: ThumbnailSelector as any });

  registerType({ type: 'accountcard', component: ManageAccountCard as any });

  registerType({ type: 'medcabinet', component: MedicineCabinetCard as any });
  registerType({ type: 'useractionwidget', component: UserActionButton as any });
  registerType({ type: 'useraction', component: UserActionButton as any });

  // Animation components
  registerType({ type: 'animation_hearts', component: HeartBurstMessage });
  registerType({ type: 'animation_circles', component: FloatingCirclesMessage });

  // Transfer/Agent indicators
  registerType({ type: 'transferred', component: AgentTransferMessage });
  registerType({ type: 'transferring', component: AgentTransferMessage });
  registerType({ type: 'agentjoined', component: AgentJoinedIndicator });
  registerType({ type: 'agentleft', component: AgentDisconnectedIndicator });
  registerType({ type: 'chat_ended', component: ChatEndedIndicator });
  registerType({ type: 'textheartanimation', component: TextWithHeart });

  // This is CRITICAL - registers the StructuredMessage component for messages with type: "structured"
  // StructuredMessage then looks at the widgetType field to render the appropriate widget
  registerType({ type: 'structured', component: StructuredMessage });

  registerType({ type: 'filecard', component: FileCard });
  registerType({ type: 'chatwrapupcard', component: ChatWrapupCard as any });
  registerType({ type: 'welcomemessage', component: WelcomeMessage });
  registerType({ type: 'welcomeback', component: WelcomeBack });

  isRegistrySeeded = true;
  console.log('[ChatbotRegistry] ✅ Widget registry seeded successfully');
}
